import { render, staticRenderFns } from "./ComprasDiretasAbertas.vue?vue&type=template&id=efba3b4e"
import script from "./ComprasDiretasAbertas.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasAbertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports